import { PropertyAccessLevel } from './propertyAccessLevel';
import { buildResiAccessScopes } from './buildResiAccessScopes';

function getGlobalAccessLevel({ unrestricted, limited, gated, minor }) {
    const populatedBucketCount = [
        unrestricted.length > 0,
        limited.length > 0,
        gated.length > 0,
        minor.length > 0
    ].filter(Boolean).length;

    if (populatedBucketCount > 1) {
        return 'mixed';
    }

    if (minor.length > 0) {
        return PropertyAccessLevel.MINOR;
    }

    if (gated.length > 0) {
        return PropertyAccessLevel.GATED;
    }

    if (limited.length > 0) {
        return PropertyAccessLevel.LIMITED;
    }

    return PropertyAccessLevel.UNRESTRICTED;
}

export function buildResiAccessSummary({ user, orgs = [], userProperties = [] }) {
    const scopes = buildResiAccessScopes({
        user,
        orgs,
        userProperties
    });

    const byPropertyId = {};
    const byOrgId = {};

    const unrestricted = [];
    const limited = [];
    const gated = [];
    const minor = [];

    scopes.forEach(scope => {
        byPropertyId[scope.propertyId] = scope;

        if (!byOrgId[scope.orgId]) {
            byOrgId[scope.orgId] = {
                orgId: scope.orgId,
                orgName: scope.org?.org_name,
                org: scope.org,
                properties: []
            };
        }

        byOrgId[scope.orgId].properties.push(scope);

        if (scope.accessLevel === PropertyAccessLevel.MINOR) {
            minor.push(scope);
        } else if (scope.accessLevel === PropertyAccessLevel.UNRESTRICTED) {
            unrestricted.push(scope);
        } else if (scope.accessLevel === PropertyAccessLevel.LIMITED) {
            limited.push(scope);
        } else if (scope.accessLevel === PropertyAccessLevel.GATED) {
            gated.push(scope);
        }
    });

    return {
        all: scopes,

        byPropertyId,
        byOrgId,

        unrestricted,
        limited,
        gated,
        minor,

        globalAccessLevel: getGlobalAccessLevel({
            unrestricted,
            limited,
            gated,
            minor
        })
    };
}